import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateCaseService=async(data)=>{
    try {
        const result = await post(`api/case/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCaseService=async(data,id)=>{
    try {
        const result = await put(`api/case/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadCaseFile=async(data)=>{
    try {
        const result = await postfd(`api/case/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseService=async(page,search,from_date,to_date,type,step=1)=>{
    try {
        const result = await get(`api/case/get?page=${page}&search=${search}&from_date=${from_date}&to_date=${to_date}&type=${type}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseFilterService=async(page,search,hearing_date,type,step=1)=>{
    try {
        const result = await get(`api/case/filter_date?page=${page}&search=${search}&hearing_date=${hearing_date}&type=${type}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DownloadCaseFilterService=async(page,search,hearing_date,type,step=1)=>{
    try {
        const result = await get(`api/case/filter_date_excel?page=${page}&search=${search}&hearing_date=${hearing_date}&type=${type}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseAdminService=async(page,search,from_date,to_date,type,step='',case_hearing_date='')=>{
    try {
        const result = await get(`api/case/get_admin?page=${page}&search=${search}&from_date=${from_date}&to_date=${to_date}&type=${type}&step=${step}&case_hearing_date=${case_hearing_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseDetailService=async(id)=>{
    try {
        const result = await get(`api/case/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteCaseService=async(id)=>{
    try {
        const result = await deleteRequest(`api/case/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const UploadCaseDocsForCaseService=async(data)=>{
    try {
        const result = await post(`api/case/upload_case_attachment_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCaseHearingDateMassService=async(data)=>{
    try {
        const result = await post(`api/case/update_mass`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}